import { production } from "./utils";
import { OfferItem } from "./entities/OfferItem";
const url = getUrl();
function getUrl() {
    if (production)
        return "https://api.pergolagroup.hu";
    return "http://127.0.0.1:8081";
}
function apiUrl(path) {
    return `${url}${path}`;
}
function getCatalog() {
    return fetch(apiUrl("/catalog"))
        .then(res => res.json())
        .then(res => {
        return res;
    });
}
function getPreviewData() {
    const pathArray = window.location.pathname.split("/");
    const item = pathArray[2];
    //const item = "MjE2IzA="
    return fetch(apiUrl("/preview/" + item + "/data"))
        .then(res => res.json())
        .then(res => {
        let item = res;
        return new OfferItem(true, item.model, item.width, item.projection, item.extras, item.left, item.right, item.close, item.far, item.frameColor, item.panelColor, item.insulatedPanel);
    });
}
async function postOfferData(offerData, files, token) {
    let response;
    const formData = new FormData();
    offerData.token = token;
    offerData.requesterPhone = offerData.requesterPhone.toString();
    const json = JSON.stringify(offerData);
    const blob = new Blob([json], {
        type: 'application/json'
    });
    formData.append("json", blob);
    if (files.length > 0) {
        Array.from(files).forEach((file) => formData.append(file.name, file));
    }
    try {
        response = await fetch(apiUrl("/request_offer"), {
            method: 'POST',
            body: formData
        });
    }
    catch (error) {
        response = error;
    }
    return response;
}
export { getCatalog, getPreviewData, postOfferData };
